// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-a456006e]{display:flex;flex-direction:column;margin-top:20px;padding:30px 20px;background-color:#fff;border-radius:3px}.base[data-v-a456006e]{display:flex;justify-content:space-between}@media screen and (max-width:1340px){.base[data-v-a456006e]{display:flex;flex-direction:column}}", ""]);
// Exports
module.exports = exports;
